import React from 'react';

import './EffectSlideIn.scss';

type EffectSlideInProps = {
    children: React.ReactElement;
    delay?: number;
};

export function EffectSlideIn({ children, delay = 0 }: EffectSlideInProps) {
    return (
        <span className="yat-artifacts__effect-slide-in">
            <span className="yat-artifacts__effect-slide-in__content" style={{ animationDelay: `${delay}ms` }}>
                {children}
            </span>
        </span>
    );
}
